module.exports = __webpack_public_path__ + "cd64008388e9569baa7ea36c815879f4.png";